<mat-toolbar>
  <h3>Purchased hours</h3>
</mat-toolbar>

<table mat-table [dataSource]="source()" [trackBy]="trackBy">
  <mat-text-column name="Hours"></mat-text-column>

  <ng-container matColumnDef="Value">
    <th mat-header-cell *matHeaderCellDef>Value Value (AUD)</th>
    <td mat-cell *matCellDef="let item">{{ item.Value | number: '1.2' }}</td>
  </ng-container>

  <ng-container matColumnDef="Expires">
    <th mat-header-cell *matHeaderCellDef>Expires</th>
    <td mat-cell *matCellDef="let item">
      <span> {{ item.ExpireMonth }} {{ item.ExpireYear }} </span>
    </td>
  </ng-container>

  <mat-text-column name="Notes"></mat-text-column>

  <ng-container matColumnDef="DueDate">
    <th mat-header-cell *matHeaderCellDef>Due Date</th>
    <td mat-cell *matCellDef="let item">
      <span [class.mat-text-error]="item.DueDate < now()"> {{ item.DueDate | date: 'dd/MM/y' }} </span>
    </td>
  </ng-container>

  <mat-text-column name="PurchaseOrder" headerText="PO"></mat-text-column>

  <ng-container matColumnDef="Invoicing">
    <th mat-header-cell *matHeaderCellDef>Invoicing</th>
    <td mat-cell *matCellDef="let item" style="text-align: center">
      @if (item.Status === 20) {
        <mat-icon [matTooltip]="statuses[item.Status]" color="accent">price_check</mat-icon>
      } @else if (item.Status === 10) {
        <button matMiniFab [matTooltip]="statuses[item.Status]" (click)="invoice(item)" [disabled]="pending()">
          <mat-icon>attach_money</mat-icon>
        </button>
      } @else {
        <button matMiniFab [matTooltip]="statuses[item.Status]" (click)="invoice(item)" [disabled]="pending()">
          <mat-icon>money_off</mat-icon>
        </button>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let item">
      <div class="cell-actions">
        @if (projects().length) {
          @if (auth.isAdminOrEditor()) {
            <button matMiniFab (click)="edit(item)" [disabled]="pending()">
              <mat-icon>edit</mat-icon>
            </button>
          }
          @if (auth.isAdmin()) {
            <button matMiniFab (click)="remove(item)" [disabled]="pending()">
              <mat-icon>delete</mat-icon>
            </button>
          }
        }
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToShow()"></tr>
  <tr mat-row *matRowDef="let item; columns: columnsToShow()"></tr>
</table>
